var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatechallengeCompvscompDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-building-45 1",
    clipPath: "url(#clip0_4583_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2H15V4H16V23H17V8L23 11V23H24V24H0V23H1V12H8V23H9V4H10V2H12V0H13V2ZM21 23V21H19V23H21ZM6 23V21H3V23H6ZM14 23V21H11V23H14ZM12 19V6H11V19H12ZM21 19V18H19V19H21ZM3 19V17H2V19H3ZM7 19V17H6V19H7ZM5 19V17H4V19H5ZM14 19V6H13V19H14ZM21 17V16H19V17H21ZM3 16V14H2V16H3ZM5 16V14H4V16H5ZM7 16V14H6V16H7ZM21 15V14H19V15H21ZM21 12.861V11.861H19V12.861H21Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4583_1685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatechallengeCompvscompDark);
export default __webpack_public_path__ + "static/media/createchallenge-compvscomp-dark.6fac2ae240340b35ed4becdaba7c411b.svg";
export { ForwardRef as ReactComponent };